exports.APP_VERSION = '2.1.20'; // DO NOT TOUCH
